// 自主分析：MPPT 電壓異常診斷要用的案場主檔維護（見 ADR-0011）。
//
// 獨立成一個專案（top nav 第四顆按鈕），不掛在「其他監控來源」底下 ——
// 那邊是第三方監控平台的即時資料，這邊是我們自己的設定主檔，兩件事。
//
// 權限走 role 文件的 otherSites[name='projectSelfAnalysis']，
// 在群組管理有自己一顆「自主分析」設定鈕。新頁面預設沒有人有權限。
export const projectSelfAnalysisRoutes = [
  {
    path: 'selfanalysis',
    name: 'selfanalysis',
    component: () => import('@/views/SelfAnalysis.vue'),
    meta: {
      release: true,
      zhTw: '案場主檔維護',
      icon: 'fas fa-sitemap',
      showMenu: true
    }
  }
]
